import React from "react";
import { HiOutlinePaperClip } from "react-icons/hi2";

// The files sent with a question, as the agent app draws a file it holds no link to: a chip with its name.
export default function PilotFiles({ files }) {
  return (
    <div className="space-y-2 text-darkergray">
      {files.map((file, index) => (
        <span
          key={file.id || `${file.name}-${index}`}
          className="inline-flex items-center gap-1 rounded-full bg-white/15 px-2 py-0.5 text-xs text-white"
        >
          <HiOutlinePaperClip className="h-3 w-3" aria-hidden="true" />
          {file.name}
        </span>
      ))}
    </div>
  );
}
